import t_10_2072_colorized from './KZ.T.10.2072.svg'
import t_10_2072 from './KZ.T.10.2072 black.svg'

export default [
  t_10_2072_colorized,
  t_10_2072
]
